import axios from "axios";

import {
  GET_LISTINGS,
  LISTING_ERROR,
  ADD_LISTING,
  SET_LISTING,
  EDIT_LISTING,
  DELETE_LISTING,
} from "./types";

// Get Users Listings
export const getListings = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `https://african-marketplace4.herokuapp.com/api/items`
    );

    dispatch({
      type: GET_LISTINGS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: LISTING_ERROR,
      payload: { msg: err.response },
    });
  }
};

// Add listing
export const addListing = (formData, history) => async (dispatch) => {
  try {
    console.log(formData);
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    const res = await axios.post(
      "https://african-marketplace4.herokuapp.com/api/items",
      formData,
      config
    );

    dispatch({
      type: ADD_LISTING,
      payload: res,
    });

    history.push("/my-listings");
  } catch (err) {
    console.log(err);
  }
};

// Add listing
export const editListing = (formData, history) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    // const body = JSON.stringify(formData);

    const res = await axios.put(
      `https://african-marketplace4.herokuapp.com/api/items/${formData.id}`,
      formData,
      config
    );

    dispatch({
      type: EDIT_LISTING,
      payload: res,
    });

    history.push("/my-listings");
  } catch (err) {
    console.log(err);
  }
};

// Get Listing by ID

export const setListing = (id, history) => async (dispatch) => {
  try {
    const res = await axios.get(
      `https://african-marketplace4.herokuapp.com/api/items/${id}`
    );

    dispatch({
      type: SET_LISTING,
      payload: res.data.item,
    });

    console.log("EditObject", res.data.item);

    history.push(`/edit-listing/${id}`);
  } catch (err) {
    dispatch({
      type: LISTING_ERROR,
      payload: { msg: err.response },
    });
  }
};

// Delete Listing

export const deleteListing = (id, history) => async (dispatch) => {
  console.log("itemId:", id);
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    const res = await axios.delete(
      `https://african-marketplace4.herokuapp.com/api/items/${id}`,
      config
    );

    console.log("delete response:", res);

    dispatch({
      type: DELETE_LISTING,
      payload: id,
    });
  } catch (err) {
    dispatch({
      type: LISTING_ERROR,
      payload: { msg: err.response },
    });
  }
};
